import { render, staticRenderFns } from "./cardswipe.vue?vue&type=template&id=6e59bbd7&scoped=true&"
import script from "./cardswipe.vue?vue&type=script&lang=js&"
export * from "./cardswipe.vue?vue&type=script&lang=js&"
import style0 from "./cardswipe.vue?vue&type=style&index=0&id=6e59bbd7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e59bbd7",
  null
  
)

export default component.exports